'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from 'react';
const STORAGE_KEY = 'hof-dashboard:hof-id';
const readStored = (): string | undefined => {
  // rendered on the server first, where there is no storage
  if ((globalThis as {
    window?: unknown;
  }).window === undefined) return undefined;
  try {
    return globalThis.localStorage.getItem(STORAGE_KEY) ?? undefined;
  } catch {
    // storage turned off, e.g. in a private window
    return undefined;
  }
};

/**
 * The Hof the user last opened on this device, so an admin of two Höfe who reloads to check an
 * upload finds the same Hof again. A Hof they no longer may open is left to the caller.
 */
export const useRememberedHofId = () => {
  const $ = _c(3);
  const [hofId, setHofId] = useState(readStored);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = next => {
      setHofId(next);
      try {
        globalThis.localStorage.setItem(STORAGE_KEY, next);
      } catch {}
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const remember = t0;
  let t1;
  if ($[1] !== hofId) {
    t1 = [hofId, remember];
    $[1] = hofId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};